import { render, staticRenderFns } from "./BusCls.vue?vue&type=template&id=3342a9d2&"
import script from "./BusCls.vue?vue&type=script&lang=js&"
export * from "./BusCls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports